import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import {Icon} from 'semantic-ui-react';
import {retrievePiggyBanks} from '../../api';
import {BlueButton, LightBlueButton} from '../../components/Button/ButtonMix';
import DurationPlusMinusToggle from '../../components/Button/DurationPlusMinusToggle';
import {currencyFormatter} from '../../util/Utils';
import ActivitySection from './ActivitySection';

const DEFAULT_ACTIVITY = {
  activity_type: 'fitness',
  total: 0,
  properties: [{
    property_key: 'vigorous_duration',
    property_value: 0
  }, {
    property_key: 'moderate_duration',
    property_value: 0
  }, {
    property_key: 'piggy_bank',
    property_value: 0
  }]
};

class Fitness extends Component {
  constructor() {
    super();
    
    this.state = {
      hasPiggyBank: false
    };
  }
  
  componentDidMount() {
    return retrievePiggyBanks()
      .then(response => {
        this.setState({hasPiggyBank: response.data.length > 0});
      });
  }
  
  onUpdatePiggyBank = value => {
    const {onChangeActivity} = this.props;
    
    // update the special piggy_bank property on the fitness activity
    onChangeActivity('fitness', 'piggy_bank', value, DEFAULT_ACTIVITY);
  };
  
  render() {
    const {hasPiggyBank} = this.state;
    const {activities, isLoading, onChangeActivity, onUpdateActivity} = this.props;
    const fitnessType = activities.find(activity => activity.activity_type === 'fitness') || DEFAULT_ACTIVITY;
    const {total, properties} = fitnessType;
    
    const vigorousDuration = properties.find(p => p.property_key === 'vigorous_duration').property_value;
    const moderateDuration = properties.find(p => p.property_key === 'moderate_duration').property_value;
    const piggyBankValue = properties.find(p => p.property_key === 'piggy_bank').property_value;
    
    const onChangeModerate = value => onChangeActivity('fitness', 'moderate_duration', value, DEFAULT_ACTIVITY);
    const onChangeVigorous = value => onChangeActivity('fitness', 'vigorous_duration', value, DEFAULT_ACTIVITY);
    
    return (
      <ActivitySection
        heading={currencyFormatter.format(total)}
        isLoading={isLoading}
        subheading="Physical Activity"
        description="How long have you exercised today?"
        nextLabel="Okay, I'm done for now"
        onNext={() => onUpdateActivity('fitness', DEFAULT_ACTIVITY)}
      >
        <DurationPlusMinusToggle value={vigorousDuration} onChange={onChangeVigorous} sectionHeader="Minutes of Vigorous Intensity"/>
        <DurationPlusMinusToggle value={moderateDuration} onChange={onChangeModerate} sectionHeader="Minutes of Moderate Intensity"/>
        {!piggyBankValue > 0 ?
          (
            <BlueButton disabled={!hasPiggyBank} onClick={() => this.onUpdatePiggyBank(1)} icon labelPosition="left">
              Use savings
              <Icon name="dollar"/>
            </BlueButton>
          ) :
          (
            <LightBlueButton onClick={() => this.onUpdatePiggyBank(0)} icon labelPosition="left">
              Undo savings
              <Icon name="undo"/>
            </LightBlueButton>
          )}
      </ActivitySection>
    );
  }
}

Fitness.propTypes = {
  activities: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onChangeActivity: PropTypes.func.isRequired,
  onUpdateActivity: PropTypes.func.isRequired
};

export default withRouter(Fitness);



// WEBPACK FOOTER //
// ./src/pages/Activities/Fitness.js